module.exports = __webpack_public_path__ + "img/exam.0799eada.svg";